import styled from 'styled-components';

export const Auth0BannerStyled = styled.section`
  padding: 48px 0;
  background-color: #ffffff;

  @media screen and (min-width: 992px) {
    padding: 88px 0;
  }
`;

export const Title = styled.h1`
  margin: 0 0 32px 0;
  font-size: 25px;
  line-height: 38px;
  text-align: center;
  font-weight: 200;
  color: rgba(6, 6, 6, 0.5);

  em {
    color: #060606;
    font-style: initial;
  }

  @media screen and (min-width: 992px) {
    grid-column: 2/6;
    font-size: 36px;
    font-weight: 200;
    line-height: 1.3;
    text-align: left;
    margin-bottom: 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 992px) {
    flex-direction: row;
    grid-column: 8/13;
    font-size: 36px;
    font-weight: 200;
    line-height: 1.3;
    text-align: left;
    margin-bottom: 0;
  }

  > button,
  > a {
    margin: 0 0 16px 0;

    @media screen and (min-width: 992px) {
      margin: 0 16px 0 0;
    }
  }
`;

export const Button = styled.a``;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Auth0Banner/styled.js